import { makeStyles } from "@material-ui/core/styles";

const playSequenceContainerStyles = makeStyles((theme) => ({
	ballPosition: {
		height: 90,
		[theme.breakpoints.only("xs")]: {
			marginTop: 50
		}
	},
	stepper: {
		height: "calc(100% - 90px)"
	}
}));

export default playSequenceContainerStyles;
